import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { useNavigate } from "react-router";
import { getAllMovementBreakStrands, getAllStrandsNew } from "../../firebase";
import { UserContext } from "../../providers/UserProvider";
import StructuredLessonItem from "../../components/StructuredLessonItem";
import StrandCategoryBox from "../../components/new-components/StrandCategoryBox";
import { Link } from "react-router-dom";
import AsyncComponent from "../../components/generic/AsyncComponent";
import { checkIfStrandIsEmpty } from "../../functions/lessonFunctions";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import pdf1 from "../../pdfs/23_24 Infants LTP.pdf";
import pdf2 from "../../pdfs/23_24 1st 2nd LTP.pdf";
import pdf3 from "../../pdfs/23_24 3rd 4th LTP.pdf";
import pdf4 from "../../pdfs/23_24 5th 6th LTP.pdf";
import pdf5 from "../../pdfs/SD Infants.pdf";
import pdf6 from "../../pdfs/SD 1st 2nd.pdf";
import pdf7 from "../../pdfs/SD 3rd 4th.pdf";
import pdf8 from "../../pdfs/SD 5th 6th.pdf";
// 2024-25 LTPs
import pdf9 from "../../pdfs/Infants LTP 24_25.pdf";
import pdf10 from "../../pdfs/1st & 2nd LTP 24_25.pdf";
import pdf11 from "../../pdfs/3rd & 4th LTP 24_25.pdf";
import pdf12 from "../../pdfs/5th & 6th LTP 24_25.pdf";
import TestBox from "../../components/new-components/TestBox";

function YearContentPage() {
  const [strandsText, setStrandsText] = useState("");
  const [strands, setStrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const { data, data2 } = useContext(UserContext);
  const navigate = useNavigate();

  const structuredLessonIds = [
    "ScyF4p5IWmW0W1nN3jdu",
    "ltmdjbUAhX827TpQZrbq",
    "33w5lRGDmjeDbiZhVvuI",
    "Lr9JFFnnTg8KY5forR28",
  ];

  useEffect(() => {
    document.title = "Daly Exercise+ | Content";
    fetchData(data2);
  }, [data2]);

  const fetchData = async (data2) => {
    if (data2.Year === 0) {
      setStrandsText("Junior & Senior");
    } else if (data2.Year === 1) {
      setStrandsText("1st & 2nd");
    } else if (data2.Year === 2) {
      setStrandsText("3rd & 4th");
    } else if (data2.Year === 3) {
      setStrandsText("5th & 6th");
    } else if (data2.Year === 10) {
      setStrandsText("Mild SEN");
    } else if (data2.Year === 11) {
      setStrandsText("Moderate SEN");
    } else if (data2.Year === 12) {
      setStrandsText("Severe-Profound SEN");
    }
    setLoading(false);
  };

  const goToStrand = (guid) => navigate(guid);

  const getPDFLink = () => {
    if (data2.Year === 0) {
      return pdf9;
    }
    if (data2.Year === 1) {
      return pdf10;
    }
    if (data2.Year === 2) {
      return pdf11;
    }
    if (data2.Year === 3) {
      return pdf12;
    }
    return pdf1;
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    // console.log(numPages);
  };

  return (
    <Container fluid>
      <div className="dashboard-body">
        <Container className="full-height">
          <h1 className="pageTitle title-margin flex-grow-1">
            Curriculum for {strandsText}
          </h1>
          <br />
          <Row className=" justify-content-center align-items-center">
            {data2.Year < 5 ? (
              <Col md={6}>
                <TestBox
                  title={"PE Plans"}
                  icon={"icon_structured_plans"}
                  color={"green"}
                  content={"Follow our structured PE Plans!"}
                  click={() =>
                    navigate(
                      `/structured-lessons/${structuredLessonIds[data2.Year]}`
                    )
                  }
                ></TestBox>
              </Col>
            ) : (
              <></>
            )}
            <Col md={6}>
              <TestBox
                title={"Strands"}
                icon={"icon_pe_strands"}
                color={"yellow"}
                content={"Everything by PE strand!"}
                click={() => navigate("/lessons")}
              ></TestBox>
            </Col>
            <Col md={6}>
              <TestBox
                title={"Movement Breaks"}
                icon={"icon_movement_breaks"}
                color={"blue"}
                content={"Our classroom workouts!"}
                click={() => navigate("/movement-breaks")}
              ></TestBox>
            </Col>
            <Col md={6}>
              <TestBox
                title={"Lesson Generator"}
                icon={"icon_generator"}
                color={"textprimary"}
                disabled={true}
                content={"Make a lesson with your equipment!"}
                click={() => navigate("/search")}
              ></TestBox>
            </Col>
          </Row>
        </Container>
      </div>
    </Container>
  );
}

export default YearContentPage;
